import { render, staticRenderFns } from "./AdminTimesheetOvertake.vue?vue&type=template&id=2d28537e"
import script from "./AdminTimesheetOvertake.vue?vue&type=script&lang=js"
export * from "./AdminTimesheetOvertake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports